import { monoValueStyles } from 'app/shared/modules/EntityAuditHistory/EntityAuditHistory.styles';

import { getConditionalObject } from 'utils/data';

export const markListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

// Rows reach past the list's edges by their padding, so their text lines up with the panel's.
const markRowStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  gap: '10px',
  margin: '0 -8px',
  padding: '6px 8px',
  borderRadius: ({ shape }) => shape.radius.m,
  textAlign: 'left',
};

export const getMarkRowStyles = ({ isSelectable, isHighlighted }) => ({
  ...markRowStyles,
  ...getConditionalObject(isHighlighted, { bgcolor: 'primary.extraSoft' }),
  ...getConditionalObject(isSelectable && !isHighlighted, {
    '&:hover, &.Mui-focusVisible': { bgcolor: 'background.hoverDefault' },
  }),
});

export const getMarkNameStyles = ({ isFieldName }) =>
  isFieldName ? { ...monoValueStyles, wordBreak: 'break-all' } : { overflowWrap: 'anywhere' };
